import { createSelector } from 'reselect';

import type { State } from 'reducers';

import { initialState } from './reducer';

const selectState = (state: State) => state.get('donationPage') || initialState;

export const selectLoading = createSelector(selectState, (state) => state.get('loading'));
export const selectError = createSelector(selectState, (state) => state.get('error'));
